var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pci-row" }, [
    _c(
      "div",
      {
        staticClass: "pci-drag",
        attrs: { title: _vm.$t("settings.dragHandleTitle") },
      },
      [_vm._v("≡")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "tippy",
            rawName: "v-tippy",
            value: {
              followCursor: true,
              placement: "right",
              theme: _vm.isDarkMode ? "light-border" : "google",
            },
            expression:
              "{\n            followCursor: true,\n            placement: 'right',\n            theme: isDarkMode ? 'light-border' : 'google',\n        }",
          },
        ],
        staticClass: "pci-main",
        attrs: { content: _vm.getContentName(_vm.child, "content") },
      },
      [
        _c("div", { staticClass: "pci-shortcut" }, [
          _vm.child.type === "ALT"
            ? _c("span", { staticClass: "pci-badge" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.isMac ? "⌃" : "Alt") +
                    "+" +
                    _vm._s(_vm.child.letter) +
                    "\n            "
                ),
              ])
            : _vm.child.type === "TAB"
            ? _c("span", { staticClass: "pci-badge" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("message.preparedContentTabSequence", {
                        letter: _vm.child.letter,
                        num: _vm.child.number,
                      })
                    ) +
                    "\n            "
                ),
              ])
            : _vm.child.type === "HASH"
            ? _c("span", { staticClass: "pci-badge" }, [
                _vm._v("#" + _vm._s(_vm.child.hash)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pci-title" }, [
          _vm._v(_vm._s(_vm.getContentName(_vm.child))),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pci-actions" },
      [
        _c(
          "SupsisButton",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("message.edit") },
                expression: "{ content: $t('message.edit') }",
              },
            ],
            attrs: { icon: "", square: "", xsmall: "" },
            on: {
              click: function ($event) {
                return _vm.$emit("edit", _vm.child._id, true)
              },
            },
          },
          [_c("md-icon", [_vm._v("edit")])],
          1
        ),
        _vm._v(" "),
        _vm.canDelete
          ? _c(
              "SupsisButton",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { content: _vm.$t("message.deleteField") },
                    expression: "{ content: $t('message.deleteField') }",
                  },
                ],
                attrs: {
                  icon: "",
                  square: "",
                  xsmall: "",
                  classNames: "pci-delete-btn",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("remove", _vm.child._id)
                  },
                },
              },
              [_c("md-icon", [_vm._v("delete")])],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }